var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "feedback-popup",
    "class": {
      'popup-form': !_vm.embedded,
      'feedback-popup--embedded': _vm.embedded,
      'feedback-popup--capture-hidden': _vm.captureHidden
    }
  }, [_c('div', {
    staticClass: "content-form-popup feedback-content"
  }, [_c('header', {
    staticClass: "feedback-header"
  }, [!_vm.embedded ? _c('button', {
    staticClass: "feedback-close",
    attrs: {
      "type": "button",
      "aria-label": "Zavrieť"
    },
    on: {
      "click": _vm.closePopup
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "close",
      "size": 24
    }
  })], 1) : _vm._e(), _c('span', {
    staticClass: "feedback-kicker"
  }, [_vm._v("Pomôžte nám zlepšiť Bankárov")]), _c('h2', [_vm._v("Nahlásiť problém")]), _c('p', [_vm._v(" Napíšte, čo sa stalo. Aktuálnu stránku a technický kontext priložíme automaticky. ")])]), _c('form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments);
      }
    }
  }, [_c('label', {
    staticClass: "feedback-field"
  }, [_c('span', [_vm._v("Čo sa stalo? *")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.message,
      expression: "message",
      modifiers: {
        "trim": true
      }
    }],
    ref: "message",
    attrs: {
      "rows": "7",
      "maxlength": "5000",
      "required": "",
      "placeholder": "Popíšte, čo ste robili, čo ste očakávali a čo sa zobrazilo..."
    },
    domProps: {
      "value": _vm.message
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.message = $event.target.value.trim();
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _c('small', [_vm._v(_vm._s(_vm.message.length) + " / 5 000")])]), _c('div', {
    staticClass: "feedback-context-card"
  }, [_vm._m(0), _c('p', {
    attrs: {
      "title": _vm.pageUrl
    }
  }, [_vm._v(_vm._s(_vm.pageUrl))]), _vm.mortgageId || _vm.clientId ? _c('div', {
    staticClass: "feedback-context-tags"
  }, [_vm.mortgageId ? _c('span', [_vm._v("Hypotéka #" + _vm._s(_vm.mortgageId))]) : _vm._e(), _vm.clientId ? _c('span', [_vm._v("Klient #" + _vm._s(_vm.clientId))]) : _vm._e()]) : _vm._e()]), _c('section', {
    staticClass: "feedback-screenshot"
  }, [_c('div', {
    staticClass: "feedback-screenshot-heading"
  }, [_vm._m(1), !_vm.screenshotFile ? _c('button', {
    staticClass: "feedback-secondary",
    attrs: {
      "type": "button",
      "disabled": _vm.capturing || _vm.saving
    },
    on: {
      "click": _vm.captureScreenshot
    }
  }, [_vm.capturing ? _c('span', [_vm._v("Pripravujem screenshot...")]) : _c('span', [_vm._v("Odfotiť obrazovku")])]) : _vm._e()]), _vm.screenshotPreview ? _c('div', {
    staticClass: "feedback-preview"
  }, [_c('img', {
    attrs: {
      "src": _vm.screenshotPreview,
      "alt": "Náhľad priloženého screenshotu"
    }
  }), _c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.removeScreenshot
    }
  }, [_vm._v(" Odobrať screenshot ")])]) : _c('p', {
    staticClass: "feedback-screenshot-help"
  }, [_vm._v(" Po kliknutí vyberte aktuálnu kartu Bankári. Formulár sa pri zábere na chvíľu skryje. ")]), !_vm.screenshotFile ? _c('label', {
    staticClass: "feedback-upload"
  }, [_c('span', [_vm._v("Nahrať existujúci obrázok")]), _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/png,image/jpeg,image/webp",
      "disabled": _vm.capturing || _vm.saving
    },
    on: {
      "change": _vm.selectScreenshot
    }
  })]) : _vm._e(), _vm.captureError ? _c('p', {
    staticClass: "feedback-error",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.captureError))]) : _vm._e()]), _vm.submitErrors.length ? _c('div', {
    staticClass: "feedback-error-list",
    attrs: {
      "role": "alert"
    }
  }, [_c('strong', [_vm._v("Feedback sa nepodarilo odoslať:")]), _vm._l(_vm.submitErrors, function (error, index) {
    return _c('span', {
      key: index
    }, [_vm._v(_vm._s(error))]);
  })], 2) : _vm._e(), _c('footer', {
    staticClass: "feedback-footer"
  }, [_c('button', {
    staticClass: "feedback-secondary",
    attrs: {
      "type": "button",
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v(" Zrušiť ")]), _c('button', {
    staticClass: "feedback-primary",
    attrs: {
      "type": "submit",
      "disabled": _vm.saving || !_vm.message
    }
  }, [_vm._v(" " + _vm._s(_vm.saving ? "Odosielam..." : "Odoslať feedback") + " ")])])])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('strong', [_vm._v("Kontext stránky")]), _c('span', [_vm._v("Priloží sa automaticky")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('strong', [_vm._v("Screenshot")]), _c('span', [_vm._v("Voliteľný, uloží sa súkromne")])]);

}]

export { render, staticRenderFns }